const cafeInSK = {
    pageID: '2',
    title: 'รวมคาเฟ่สุดเจ๋งจากสกลนคร',
    prevDescription: 'ไอ้หนุ่มเสื้อเขียวมีคาเฟ่สุดเจ๋งในจังหวัดสกลนครมาแนะนำกัน หากทุกคนพร้อมแล้วล่ะก็มาเริ่มกันได้เลย !',
    topicDescription: 'สำหรับใครที่เป็นสาย Cafe\' นั้นพลาดไม่ได้เลยกับหัวข้อที่จะมาแนะนำในวันนี้ เพราะเรามี 10 คาเฟ่สุดเจ๋งจากจังหวัด <b>สกลนคร</b> มาแนะนำกัน ไม่ว่าคุณจะเป็นสายกิน สายถ่ายรูป สายคอนเทนท์ หรือ สายไหนๆก็ห้ามพลาดกันเลยทีเดียว เมื่อทุกคนพร้อมแล้ว... ก็ตามไปกันได้เลย !',
    previewImg: 'https://img.wongnai.com/p/624x0/2021/12/19/5309e2380b1e4575a2f40eaa59dd1a69.jpg',

    data: [
        {
            id: 1,
            title: 'Sweet Cottage Bakery & Tea Room',
            description: 'คาเฟ่สกลนครที่ฮอตฮิตไม่เคยเปลี่ยน การตกแต่งร้านเป็นสวนสวย ๆ เอาคะแนนเต็มไปเลยสำหรับสวน เดินผ่านประตูรั้วเข้ามาก็จะเจอกับน้ำพุสวย ๆ สไตล์กรีกโรมัน ภายในร้านตกแต่งโทนดำ ดูอบอุ่นครับ ร้านนี้จะเด่นเรื่องเมนูเครื่องดื่มและขนมต่าง ๆ แนะนำ “Taro Cake With Coconut Cream” กับ “เค้กมะพร้าวอ่อน” มาเที่ยวสกลนครทีไร ก็จะต้องแวะมาร้านนี้ แนะนำเลย',
            src: 'https://img.wongnai.com/p/624x0/2020/10/17/b1e529c943d3406686b3deac1c71f577.jpg',
        },
        {
            id: 2,
            title: 'Sonata\'s siberian Cafe',
            description: 'จัดว่าเป็นคาเฟ่สกลนครที่น่ารักมาก ใครมาเที่ยวสกลนคร แวะมาเล่นกับน้องหมากันนะ แล้วอาหารของที่นี่ก็รสชาติดีทุกเมนู ขนมก็รสชาติดีมาก ๆ เช่นกัน เมนูเด็ดของทางร้านต้องยกให้ "ช็อกโกแลต" เลย',
            src: 'https://img.wongnai.com/p/624x0/2021/12/19/5309e2380b1e4575a2f40eaa59dd1a69.jpg',
        },
        {
            id: 3,
            title: 'คำหอม สกลนครรัฐพัฒนา ซอย5',
            description: 'คาเฟ่สกลนครในเมือง เลี้ยวเข้าซอยมานิดเดียว หาง่าย ร้านมีภาพวาดแขวนโชว์ไว้เยอะเลย เดินเข้ามาข้างในจะมีพวกสินค้า OTOP ของสกลนครขายด้วย ใครชอบกิน “บิงซู” ร้านนี้มีหลายเมนูให้เลือก ทางด้านอาหารก็มีบริการเช่นกัน ได้ลองเป็น “หมูทอดทงคัตสึ” กินกับสลัด รสชาติดี หมูทอดไม่มัน ไม่เหนียว ส่วนเครื่องดื่มอย่าง “โกโก้ปั่น” ก็รสชาติดีใช้ได้ ไม่หวานจัด',
            src: 'https://img.wongnai.com/p/624x0/2021/02/28/3248444180bf4375aec440385d7b98ae.jpg',
        },
        {
            id: 4,
            title: 'Studio Cafe\'',
            description: 'ร้านกาแฟสกลนครสวย ๆ ร้านนี้ ตั้งอยู่แถว ๆ หลังบิ๊กซี วันนี้แวะมาลองในช่วงบ่าย ๆ บรรยากาศร้านเป็นสวน ตกแต่งร่มรื่นมาก ๆ ภายในร้านก็บรรยากาศดี เป็นคาเฟ่สกลนครสไตล์โมเดิร์น ดูขรึม ๆ แต่อบอุ่นดี ได้สั่งมาเป็น “Orange Americano” มาแก้วนึง เพราะอยากดื่มอะไรที่สดชื่น ถือว่าทำมาดีเลย น้ำส้มคั้นรสชาติเยี่ยม เข้ากันกับช็อตกาแฟที่ใส่มาด้านบน สดชื่นจริง ๆ หอม ๆ',
            src: 'https://img.wongnai.com/p/624x0/2018/10/14/2f7d05bbc4124ed2a07cc5e417010ff3.jpg',
        },
        {
            id: 5,
            title: 'สุขเกษม คอฟฟี่ แอนด์ เรสเตอรองค์สกลนคร',
            description: 'เที่ยงนี้ฝากท้องที่คาเฟ่สกลนครอย่างร้านสุขเกษม Coffee & Restaurant อาหารราคาถูก กับแอร์เย็น ๆ เหมาะกับในชั่วโมงเร่งรีบ มีทั้งของหวาน เค้ก กาแฟ น้ำหวาน ถือว่าเยี่ยม ทำอาหารเร็วมากแบบน่าตกใจ',
            src: 'https://img.wongnai.com/p/624x0/2020/12/17/54cb0e1b38a341ab8aff7029fd4a735f.jpg',
        },
        {
            id: 6,
            title: 'บ้านฟ้าโปร่ง',
            description: 'คนท้องถิ่นสกลนครแนะนำคาเฟ่สกลนครร้านนี้ มีเครื่องดื่ม อาหารคาวทั้งไทยเทศ ขนม ครบเครื่อง บรรยากาศดี ร่มรื่น เมนูที่พลาดไม่ได้คือ "เอแคลร์" ไส้แน่น ไม่หวาน ลูกใหญ่สะใจ เค้กรสชาติดีหลายอย่าง อาหารไทย "ยำ" "ส้มตำ" "น้ำพริก" แม่ครัวมีฝีมือดีเด่น พนักงานตั้งใจบริการเป็นอย่างดี',
            src: 'https://img.wongnai.com/p/624x0/2019/11/26/7683aff9eabe40d891b388c4ad5ef336.jpg',
        },
        {
            id: 7,
            title: 'Moon Cafe',
            description: 'ร้านนี้เป็นคาเฟ่สกลนครอีกร้านที่ชื่นชอบเลย กาแฟหอมรสชาติดี ร้านโปร่งโล่งนั่งสบาย บาริสตาน่ารัก ค่อย ๆ ทำงานค่อย ๆ คุยเบา ๆ ลูกค้าที่นั่งร้านได้ความเป็นส่วนตัวดีมาก ๆ เลย วันนี้สั่ง "เดอร์ตีลาเต้" "อเมริกาโน" "ยุซุ" หลาย ๆ อย่างมาชิม รวม ๆ กัน รสชาติดีเลย ราคาไม่แพง มาลองกันได้เลย',
            src: 'https://img.wongnai.com/p/624x0/2022/05/28/93ae5d3f79284d99abfa4aa9f8eb1f5e.jpg',
        },
        {
            id: 8,
            title: 'Wise Cafe',
            description: 'เป็นคาเฟ่สกลนครในสไตล์มินิมอลสีขาวสะอาดตา มีบริการขนมอบต่าง ๆ รวมถึงกาแฟหอมกลมกล่อมเข้ากันได้ดีกับขนมอย่าง “บลูเบอร์รีครัมเบิลมัฟฟิน” ทางด้าน “ช็อกโกแลตปั่น” เพื่อนที่สั่งมาก็บอกว่ารสชาติดี ขอประเดิมคะแนนเต็มให้ร้านนี้เลยนะ ครั้งนี้มาแบบรีบ ๆ แต่ส่วนตัวชอบมากเลยสำหรับร้านนี้',
            src: 'https://img.wongnai.com/p/624x0/2021/05/14/0f1e4401d01d4ebba8f816cba30c8e7d.jpg',
        },
        {
            id: 9,
            title: 'Get Idea Coffee',
            description: 'ร้านคาเฟ่สกลนครกลางเมือง มีขนมเค้ก มีอาหารเช้า และเมนูอาหารอื่น ๆ ร้านมีภาพวาดขาย ทำคล้าย ๆ Gallery ภาพ นั่งได้เพลิน ๆ วันนี้สั่ง "Chocolate เย็น" เพิ่ม Shot กาแฟ รสชาติเข้มข้น กาแฟไม่มีกลิ่นไหม้ ไม่หวานมาก',
            src: 'https://img.wongnai.com/p/624x0/2019/11/02/99b58cdd92714e82ba93eacdee77164e.jpg',
        },
        {
            id: 10,
            title: 'MOKA FOX',
            description: 'คาเฟ่สกลนครร้านสวยมาก มีความโฮมมีมาก ๆ ผสมผสานระหว่างไม้ และกระจก กึ่ง ๆ Scandinavian เครื่องดื่มก็ดีเลย Drip พร้อมเมล็ด Single ให้เลือก วันนี้เลือกเมล็ด Hondurus รสชาตินุ่ม ดีมาก ๆ "มอคคาเย็น" มีความเข้มข้นของโกโก้ รสชาติดี',
            src: 'https://img.wongnai.com/p/624x0/2024/03/31/483c84f925804c48970d525b2a17673d.jpg',
        },
    ]
}

export default cafeInSK